const initState = {
  sportContests: [],
  lastVisible: null,
  hasMore: true,
  contestOrganizer: null,
  contestDetails: {
    data: [],
    lastVisible: null,
    hasMore: true,
  },
  brandAmbassodarContestData: [],
  brandAmbassodarContestLastDocument: null,
  brandAmbassodarContestHasMoreDocument: true,
  SportContestData: [],
  SportlastDocument: null,
  SporthasMoreDocument: true,
};

const contestReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_CONTESTS_SUCCESS":
      return {
        ...state,
        sportContests: action.payload.isLoadingMore
          ? [...state.sportContests, ...action.payload.data]
          : action.payload.data,
        lastVisible: action.payload.lastVisible,
        hasMore: action.payload.hasMore,
      };
    case "PARTICIPATE_CONTEST_SUCCESS":
      return {
        ...state,
        sportContests: state.sportContests?.map((contest) =>
          contest.id === action.payload
            ? { ...contest, participated: "participated" }
            : contest
        ),
      };
    case "FETCH_CONTESTS_ORGANIZER_SUCCESS":
      return {
        ...state,
        contestOrganizer: action.payload,
      };
    case "FETCH_CONTESTS_DETAILS_SUCCESS":
      return {
        ...state,
        contestDetails: {
          data: action.payload.isLoadingMore
            ? [...state.contestDetails.data, ...action.payload.data]
            : action.payload.data,
          lastVisible: action.payload.lastVisible,
          hasMore: action.payload.hasMore,
        },
      };
    case "GET_BRAND_AMBASSODAR_CONTEST":
      return {
        ...state,
        brandAmbassodarContestData: action.payload.data,
        brandAmbassodarContestHasMoreDocument: action.payload.hasMoreDocument,
        brandAmbassodarContestLastDocument: action.payload.lastDocument,
      };

    case "GET_BRAND_AMBASSODAR_CONTEST_MORE":
      return {
        ...state,
        brandAmbassodarContestData: [
          ...state.brandAmbassodarContestData,
          ...action.payload.data,
        ],
        brandAmbassodarContestHasMoreDocument: action.payload.hasMoreDocument,
        brandAmbassodarContestLastDocument: action.payload.lastDocument,
      };

    case "GET_SPORT_CONTEST_DATA":
      return {
        ...state,
        SportContestData: action.payload.data,
        SporthasMoreDocument: action.payload.hasMoreDocument,
        SportlastDocument: action.payload.lastDocument,
      };
    case "GET_SPORT_CONTEST_DATA_MORE":
      return {
        ...state,
        SportContestData: [...state.SportContestData, ...action.payload.data],
        SporthasMoreDocument: action.payload.hasMoreDocument,
        SportlastDocument: action.payload.lastDocument,
      };
    default:
      return {
        ...state,
      };
  }
};
export default contestReducer;
